function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m56 24v-14.344c0-1.0612-0.42125-2.0775-1.1712-2.8288l-5.6575-5.6562c-0.75-0.75-1.7675-1.1712-2.8288-1.1712h-34.342c-2.2088 0-4 1.7912-4 4v20c-4.4188 0-8 3.5812-8 8v14c0 1.105 0.895 2 2 2h6v12c0 2.2088 1.7912 4 4 4h40c2.2088 0 4-1.7912 4-4v-12h6c1.105 0 2-0.895 2-2v-14c0-4.4188-3.5812-8-8-8zm-8 32h-32v-12h32zm0-28h-32v-20h24v6c0 1.105 0.895 2 2 2h6zm6 9c-1.6562 0-3-1.3438-3-3 0-1.6575 1.3438-3 3-3s3 1.3425 3 3c0 1.6562-1.3438 3-3 3z",
    fill: "currentColor",
    style: {
      strokeWidth: 0.125
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.a9219818.svg";
export { ForwardRef as ReactComponent };